import { useEffect, useState } from "react";
import { IProjectOverview } from "models/projects";
import useCentralApi from "hooks/shared/useCentralApi";
import { useCurrentUser } from "hooks/shared";
import TagManager from 'react-gtm-module';

type GetProjectOverviewResult = IProjectOverview | null;
type UseProjectOverviewResult = [
    GetProjectOverviewResult,
    boolean,
    string | null
];

const useProjectOverview: (projectId: string | undefined) => UseProjectOverviewResult = (projectId: string | undefined) => {
    const [ result, setResult ] = useState<GetProjectOverviewResult>(null);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(false);
    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {
        const controller = new AbortController();
        if (projectId && projectId != '0' && projectId != '') {
            (async () => {

                //#region Google Analytics Dev Testing
                /*
                const tagManagerArgs = {
                gtmId: process.env.REACT_APP_GTM_ID as string,
                    events: {
                        sendUserInfo: { 'userId': user ? user.id_token : 'userid' }
                    }
                };
                TagManager.initialize(tagManagerArgs);
                */
                //#endregion

                setLoading(true);
                try {
                    const resp = await fetcher(`/api/v3/projects/${projectId}`, {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json() as IProjectOverview;
                    setResult(data);
                } catch (err) {

                } finally {
                    setLoading(false);
                }
            })(); 
        }
        return () => controller.abort();
    }, [ user, projectId ]);

    return [
        result,
        loading,
        error
    ];
};

export default useProjectOverview;